export const layoutBorder = `solid 1px #F3F3F3`
